import company from './company'
import department from './department'
import project from './project'
import qualification from "./qualification";
import user from './user'
import person from './person'
import userGroup from './userGroup'
import role from './role'
import permission from './permission'
import position from "./position";
import positionGrade from "./positionGrade";
import report from "./report";
export default [{
    path: '/organization',
    component: () => import('@/views/organization/organization.main'),
    children: [
        {
            path: 'tree',
            component: () => import('@/views/organization/tree/organization.tree')
        },
        {
            path: 'tree-table',
            component: () => import('@/views/organization/tree/organization.tree.table')
        },
        ...user,
        ...person,
        ...userGroup,
        ...role,
        ...company,
        ...department,
        ...project,
        ...qualification,
        ...position,
        ...positionGrade,
        ...permission,
        ...report,
    ]
}]